import axios from 'axios';

const _getFromServer = async () => {
  const url = _getServerUrl();

  try {
    const response = await axios.get(`${url}/userLocations`);
    return response.data;
  } catch (error) {
    console.log('Could not load user locations', error);
  }
};

const _getServerUrl = () => {
  return 'https://backend.yepstr.com/maps';
};

export const fetchUsersLocations = () => {
  return async (dispatch, getState) => {
    try {
      const userLocations = await _getFromServer();

      const temp = {
        customerCount: userLocations.customers.length,
        customers: userLocations.customers,
        yepCount: userLocations.yeps.length + 10000,
        yeps: userLocations.yeps,
      };
      dispatch(fetchUserLocationCompleted(temp));
    } catch (error) {
      dispatch(fetchUserLocationFailed());
    }
  };
};

function fetchUserLocationCompleted(userLocations) {
  return {
    type: 'FETCH_USER_LOCATIONS_COMPLETED',
    userLocations,
  };
}
function fetchUserLocationFailed() {
  return {
    type: 'FETCH_USER_LOCATIONS_FAILED',
  };
}

const initialState = {
  userLocations: {
    customers: [],
    yeps: [],
    yepCount: 0,
    customerCount: 0,
  },
};

export const NAME = 'mapReducer';

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_USER_LOCATIONS_COMPLETED': {
      return {
        ...state,
        userLocations: action.userLocations,
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
